import React, { useState } from "react";
import Header from "../component/bak/Header";
import MenuPage from "../component/bak/MenuPage";
import { Route, Routes, useLocation } from "react-router-dom";
import MemberList from "./hanwool/MemberList";
import Test_hanwool from "./hanwool/test_hanwool";
import FileTree from "../asv/file-storage/FileTree";
import Datagride_hanwool from "./hanwool/Datagride_hanwool";
import MemberPage from "./admin/MemberPage";
import CmsPage from "./admin/CmsPage";
import { Box } from "@mui/material";
import AttendancePage from "./admin/AttendancePage";
import DragDrop from "../component/common/fileupload/FileDragDrop";

const Member = () => {
  var loc = useLocation();
  console.log("loc", loc);

  return (
    <Box>
      <Routes>
        <Route path="management" element={<MemberPage />} />
        <Route path="attendance" element={<AttendancePage />} />
        <Route path="cms" element={<CmsPage />} />
        <Route path="list" element={<MemberList />} />
        <Route path="hanwool" element={<Test_hanwool />} />
        <Route path="wools" element={<Datagride_hanwool />} />
        <Route path="tree" element={<FileTree />} />
        <Route path="upload" element={<DragDrop />} />
        {/* <Route path="calendar" element={<Calendar />} /> */}
      </Routes>
    </Box>
  );
};

export default Member;
